/**
 * 特色资源
 * 2017-12-08
 * fang.lijuan
 */
'use strict';
angular.module('featuredResourceModule', [
    'featuredResourceLeftModule', // 特色资源左侧导航
    'featuredResourceRouterModule', // 特色资源路由
    'resCenRobotModule', // 机器人稿
    'resCenPushModule', // push稿
    'resCenToutiaoModule', // 头条稿
]);
